module.exports = __webpack_public_path__ + "static/media/_Hebrock_brochure_K_series_en.a7005631.pdf";